import { Skeleton } from "@tellescope/ui";

export const AISummaryLoading = () => (
  <div className="flex flex-col gap-2 rounded-lg border border-purple-200 bg-gradient-to-r from-purple-50 to-gray-50 p-4">
    <div className="mb-1 flex items-center justify-between">
      <Skeleton className="h-4 w-32" />
      <Skeleton className="h-4 w-16" />
    </div>
    <Skeleton className="h-3 w-full" />
    <Skeleton className="h-3 w-full" />
    <Skeleton className="h-3 w-3/4" />
  </div>
);
